module.exports = __webpack_public_path__ + "img/the_mirror_of_erised.79a29485.jpg";